const hasPastError = (errors) =>
  Object.values(errors || {})
    .reduce((acc, errorsInKey) => [...acc, ...(errorsInKey || [])], [])
    .some((errorKey) => errorKey === 'past');

export default hasPastError;
